import {z} from 'zod';

import {PASSWORD_REQUIREMENTS} from 'presentation/constants';

export const passwordSchema = z
	.string()
	.trim()
	.min(6, PASSWORD_REQUIREMENTS.EXACT_LENGTH)
	.regex(/[!@#$%^&*(),.?":{}|<>]/, PASSWORD_REQUIREMENTS.HAS_SPECIAL_CHAR)
	.regex(/\d/, PASSWORD_REQUIREMENTS.HAS_NUMBER)
	.regex(/[A-Z]/, PASSWORD_REQUIREMENTS.HAS_UPPERCASE)
	.regex(/[a-z]/, PASSWORD_REQUIREMENTS.HAS_LOWERCASE);

export const formSchema = z
	.object({
		password: passwordSchema,
		repeatPassword: z.string(),
	})
	.refine(val => val.repeatPassword === val.password, {
		message: PASSWORD_REQUIREMENTS.MATCH_PASSWORDS,
		path: ['repeatPassword'],
	});

export type IFormData = z.infer<typeof formSchema>;
